export const pages = [
  {
    route: '/electricity',
    banner: './electricityPage.jpg',
    title: 'Electricity',
    data: [
      {
        para: (
          <div className="p-4">
          <p className='w-full p-4'>
            Since the deregulation in the energy market, many changes have taken
            place with the most significant one is the price increases.
            Electricity costs has increased by over 70% in the past few years
            while natural gas prices has increased by over 50% in the same
            period.
            <br />
            <br />
            Utilities save will provide you with the best prices which will give
            you the maximum savings according to your consumption as it is very
            difficult for the customers to get the best deal in the UK energy
            market due to the many thousands of tariffs and their regularity of
            change. Utilities save will provide you with no obligation service
            with highly competitive prices from our extensive list of suppliers.
          </p>
          </div>
        ),
        
        
        image:
          'https://images.unsplash.com/photo-1543489816-c87b0f5f7dd4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80' ,
        
      },
      
      
      {
        para: (
          <div className="p-4">
          <p className='w-full p-4'>
            If your contract is due for renewal we will get back to you as soon
            as possible with the best prices. If it is not due for renewal we
            will contact you at the right time for you to avoid expensive out of
            contract rates and provide you with the best options for your
            business in the market at that time, on a no obligation basis. We
            will save up to 40% on your electricity bills.
            <br />
            <br />
            If you do wish to proceed we will take care of everything. We will
            manage the entire switching process if you have decided to switch
            supplier or we will arrange your new contract terms for renewal with
            your existing supplier if you want to stay with the same supplier.
          </p>
          </div>
        ),
        image:
          'https://images.unsplash.com/photo-1610028290816-5d937a395a49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
      },
      
    ],
  },
  {
    route: '/about',
    title: 'About Us',
    banner: './aboutusScreen.png',
    data: [
      {
        para: (
          <div className="p-10">
          <p className='w-full p-4'>
            Utilitiessave hit the energy market in 2016 with one mission: to
            help businesses save as much money as possible on their gas and
            electricity. Here at utilities save, our aim is to provide you with
            maximum savings and best services for your business utilities. We
            search across most of the UK suppliers both small and large and
            identify what is the best possible deal for your business.
            <br />
            <br />
            Our experts aim to find you the best possible deal be it electricity
            or gas. Using our industry contacts and experience we aim to provide
            you with no obligation service with highly competitive prices from
            our extensive list of suppliers. The unique feature whereby we offer
            cheaper electric & gas bill along with unique energy reduction cost
            services
          </p>
          </div>
        ),
        image: './aboutUs.png',
      },
    ],
  },
  {
    route: '/gas',
    title: 'Gas',
    banner: './gasScreen.png',
    data: [
      {
        para: (
          <p className='w-full p-10'>
            Utilities save will be analyzing the market constantly to review the
            prices and product available in the commercial gas market. We will
            do our best to get you with the most suitable prices for your gas.
            Utilities save will provide you with no obligation service with
            highly competitive prices from our extensive list of suppliers. We
            will save up to 40% on your gas bills.
            <br />
            <br />
            If your gas contract is due for renewal we will get back to you as
            soon as possible with the best prices. If it is not due for renewal
            we will contact you at the right time for you to avoid expensive out
            of contract rates and provide you with the best options for your
            business in the market at that time, on a no obligation basis. So
            why to waste time thinking and calculating when you can get the best
            deal through Utilities Save.
          </p>
        ),
        image:
          'https://images.unsplash.com/photo-1607324772107-8ad6740ca195?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
      },
    ],
  },
  {
    route: '/water',
    title: 'Water',
    banner: './waterScreen.png',
    data: [
      {
        para: (
          <p className='w-full p-10'>
            From April 2017, the laws changed allowing business & charities to
            seek better deals for water. This change has created competition in
            the non-domestic water market with more retail suppliers entering
            the marker every year.
            <br />
            <br />
            The law changes means that companies in England and Scotland can
            switch their business water supplier. However, in Wales, businesses
            are only allowed to switch if consumption is over 5000m³ of water
            per year. To be eligible to switch water supplier, the registered
            business address must meet the location requirements.
          </p>
        ),
        image:
          'https://images.unsplash.com/photo-1483004406427-6acb078d1f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80 ',
      },
    ],
  },
]
